import { Box, Grid2 as Grid, Typography } from '@mui/material';

import MobileContentBG from '../../assets/mobileContentBG.png';
import React from 'react';
import content_Bg from '../../assets/ContentBG.webp';
import creativityImg from '../../assets/game.png';

interface LearningProps {
  isMobile?: Boolean | null;
}

const FunLearning: React.FC<LearningProps> = ({ isMobile }) => {
  const renderImage = () => (
    <Grid size={{ xs: 12, md: 4 }}>
      <Box display="flex" justifyContent="center" alignItems="center">
        <img
          src={creativityImg}
          alt="learning"
          style={{
            width: isMobile ? '350px' : 570,
            height: isMobile ? '233px' : 'auto',
            margin: 0
          }}
        />
      </Box>
    </Grid>
  );

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden'
      }}>
      <Grid container justifyContent="center" alignItems="center">
        {!isMobile && renderImage()}
        <Grid
          container
          display="flex"
          justifyContent="center"
          alignItems="center"
          size={{ xs: 12, md: 8 }}
          sx={{ display: { xs: 'none', md: 'flex' } }}>
          <Box p={6}>
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px',
                lineHeight: '1',
                display: 'flex',
                alignItems: 'center'
              }}>
              <span style={{ color: 'white' }}>{`“  `}</span>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`  Unlock Your Potential- `}
              </span>
            </Typography>

            {/* <Typography
              style={{
                fontFamily: 'Bevan',
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '48px'
              }}>
              {`superpower - dream,`}
            </Typography> */}
            <Typography
              style={{
                fontFamily: 'Bevan',
                fontSize: '48px'
              }}>
              <span
                style={{
                  background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                {`Quests & Contests `}
              </span>

              <span style={{ color: 'white' }}>{`”`}</span>
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Baloo2',
                color: '#fff',
                whiteSpace: 'pre-line',
                fontSize: '19px'
              }}>
              Children take on fun, skill-based challenges & quests across various {'\n'}
              creative fields. By completing these targets, they earn valuable accolades &{'\n'}
              generate redeemable CV coins.
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" alignItems="center">
        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{
            display: { xs: 'block', md: 'none' },
            margin: '30px 0'
          }}>
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span style={{ color: 'white' }}>{`“ `}</span>
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`  Unlock Your Potential-`}
            </span>
          </Typography>

          {/* <Typography
            fontSize={20}
            fontWeight={800}
            fontFamily={'Bevan'}
            align="center"
            sx={{
              background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }}>
            superpower - dream,
          </Typography> */}
          <Typography fontSize={20} fontWeight={800} fontFamily={'Bevan'} align="center">
            <span
              style={{
                background: 'linear-gradient(232.05deg, #FFDD01 19.84%, #FFB82A 92.22%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              {`Quests & Contests `}
            </span>

            <span style={{ color: 'white' }}>{`”`}</span>
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Baloo2',
              fontWeight: 500,
              fontSize: '15px',
              pt: '10px',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              textAlign: 'center',
              margin: '0 40px'
            }}>
            Children take on fun, skill-based challenges & quests across various {'\n'}
            creative fields. By completing these targets, they earn valuable accolades &{'\n'}
            generate redeemable CV coins.
          </Typography>
        </Grid>
        {isMobile && renderImage()}
      </Grid>
    </Box>
  );
};

export default FunLearning;
